import styled from 'styled-components'

const darkColor = (props) => props.theme.global.colors['dark-2']
const linkColor = (props) => props.theme.global.colors['blueLink']

export const ChatWithUsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  margin-top: 32px;

  @media screen and (max-width: 992px) {
    margin-top: 24px;
  }
`

export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px; 
  margin: 0;
  color: ${darkColor}
`

export const ChatButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
  color: ${linkColor};
  cursor: pointer;
`